import React from 'react';
import style from './style.scss';
import {Link, withRouter} from 'react-router-dom';
import BusinessContentContainer from './BusinessContentContainer.jsx';
import BusinessPageHeader from './BusinessPageHeader.jsx';
import ItemPayment from './ItemPayment.jsx';
import BusinessProductCategories from './BusinessProductCategories.jsx';
import SignInToBusinessForm from './SignInToBusinessForm.jsx';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import {ItemCategory} from 'components/partials/item-category';
import {RightStickerContainer} from 'components/partials/right-sticker';
import {Businesses, Categories} from 'api';
import {toastr} from 'react-redux-toastr';
import {ShowIf} from 'components/utils';
import {NoContent} from 'components/no-content';
import ContactBusiness from './ContactBusiness.jsx';
import {LoadingPage} from 'components/loading-page';
import {ListProductResult} from 'components/list-product/list-product-result';
import {parse} from 'qs';
import isEmpty from 'lodash/isEmpty';
import {connect} from 'react-redux';

class Business extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      listCategories: [],
      business: null,
      viewAll: false,
      tabIndex: 0,
      data: [],
      count: 0,
      skip: 0,
      limit: 10,
      isLoading: true,
      query: parse(this.props.location.search.substr(1))
    };

    this.onSelectTab = this.onSelectTab.bind(this);
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.view) {
      this.setState({tabIndex: 2});
    }
    if (this.props.params.slug) {
      this.getBusinessInfoBySlug(this.props.params.slug);
    } else {
      this.getBusinessInfo(this.props.params.id);
    }
  }

  getBusinessInfoBySlug(slug) {
    this.setState({isLoading: true});
    Businesses.actions.getBySlug.request({name: slug}).then((response) => {
      this.setState({business: this.updateBusinessInfo(response.data)});
      document.title = response.data && response.data.name ? response.data.name : 'DaklakTrade';
      if (!isEmpty(this.state.query)) {
        let params = {
          id: this.state.query.category,
          filter: {
            where: {
              businessId: response.data.id
            }
          }
        };
        params.filter = JSON.stringify(params.filter);
        Categories.actions.countFixProduct.request(params).then((response) => {
          this.setState({count: response.data.count, data: []});
          this.getBusinessCategoryProducts(this.state.query.category);
        }).catch((error) => {
          this.props.history.push(`/business/${this.state.business.id}`);
        });
      }
      this.getBusinessCategories(response.data.id);
    }).catch((error) => {
      this.setState({isLoading: false});
      toastr.error('Lỗi!', 'Không tìm thấy doanh nghiệp này.');
      this.props.history.push('/');
    });
  }

  componentWillReceiveProps(nextProps) {
    let query = parse(nextProps.location.search.substr(1));
    this.setState({query});
    if (!isEmpty(query) && query.category !== this.state.query.category) {
      let params = {
        id: query.category,
        filter: {
          where: {
            businessId: this.state.business.id
          }
        }
      };
      params.filter = JSON.stringify(params.filter);
      Categories.actions.countFixProduct.request(params).then((response) => {
        this.setState({count: response.data.count, data: []});
        this.getBusinessCategoryProducts(query.category);
      }).catch((error) => {
        this.props.history.push(`/business/${this.state.business.nameSlug}`);
      });
    }
  }

  getBusinessInfo(id) {
    this.setState({isLoading: true});
    Businesses.actions.get.request({id}).then((response) => {
      this.setState({business: this.updateBusinessInfo(response.data)});
      if (!isEmpty(this.state.query)) {
        let params = {
          id: this.state.query.category,
          filter: {
            where: {
              businessId: response.data.id
            }
          }
        };
        params.filter = JSON.stringify(params.filter);
        Categories.actions.countFixProduct.request(params).then((response) => {
          this.setState({count: response.data.count, data: []});
          this.getBusinessCategoryProducts(this.state.query.category);
        }).catch((error) => {
          this.props.history.push(`/business/${this.state.business.nameSlug}`);
        });
      }
      this.getBusinessCategories(response.data.id);
    }).catch((error) => {
      this.setState({isLoading: false});
      toastr.error('Lỗi!', 'Không tìm thấy doanh nghiệp này.');
      this.props.history.push('/');
    });
  }

  getBusinessCategoryProducts(categoryId) {
    let params = {
      id: categoryId,
      filter: {
        limit: this.state.limit,
        skip: this.state.skip,
        where: {
          businessId: this.state.business.id
        }
      }
    };
    params.filter = JSON.stringify(params.filter);
    this.setState({isLoading: true});
    Categories.actions.listFixProducts.request(params).then(response => {
      if (response && response.data) {
        let products = this.state.data;
        response.data.map((item, idx) => {
          products.push(item);
        });
        this.setState({data: products, isLoading: false});
      }
    }).catch(() => {
      this.setState({isLoading: false});
    });
  }

  updateBusinessInfo(business) {
    if (business.requestUpdateInfo)
      return Object.assign({}, business, business.requestUpdateInfo);
    else {
      return business;
    }
  }

  loadMore() {
    this.setState({skip: this.state.skip + 10}, () => {
      this.getBusinessCategoryProducts(this.state.query.category);
    });
  }

  getBusinessCategories(id) {
    Businesses.actions.getProductCategories.request({id}).then((response) => {
      this.setState({listCategories: response.data.body, isLoading: false});
    }).catch(() => {
      this.setState({isLoading: false});
    });
  }

  viewAll() {
    this.setState({
      viewAll: !this.state.viewAll
    });
  }

  scrollToCategory(item) {
    let id = item.id;
    if (document.getElementById(id)) {
      let element = document.getElementById(id);
      let windowScroll = document.documentElement.scrollTop;
      window.scroll({
        top: windowScroll + element.getBoundingClientRect().top,
        left: 0,
        behavior: 'smooth'
      });
    }
  }

  onSelectTab(tabIndex) {
    this.setState({tabIndex});
  }

  render() {
    const {isLoading, skip, limit, count, tabIndex, viewAll} = this.state;
    if (!this.state.business) {
      return null;
    }
    return (
      <section className='center'>
        <LoadingPage isShow={isLoading} />
        <div className="business-wrapper business-dashboard">
          {
            this.state.business &&
            <BusinessPageHeader business={this.state.business}/>
          }

          <div className='business-content-wrapper'>
            <div className='business-left-content'>
              <div className='business-info'>
                <Tabs className='business-tab tab-heading' selectedIndex={tabIndex} onSelect={index => this.onSelectTab(index)}>
                  <TabList>
                    <div className="business-tab-wrap">
                      <Tab className='business-tab-item'><h3 className='business-info-title'>Thông tin doanh nghiệp</h3></Tab>
                      <Tab className='business-tab-item'>
                        <ShowIf condition={this.state.business.paymentInfo}>
                          <h3 className='business-info-title'>Hình thức thanh toán</h3>
                        </ShowIf>
                      </Tab>
                      <Tab className='business-tab-item'><h3 className='business-info-title'>Liên hệ doanh nghiệp</h3></Tab>
                    </div>
                  </TabList>
                  <TabPanel className='business-tab-panel'>
                    <div className='business-tab-panel-wrap'>
                      <div className={viewAll ? 'business-info-des watched' : 'business-info-des'}>

                        <div dangerouslySetInnerHTML={{__html: this.state.business.description}}></div>
                        {
                          this.state.business.contents &&
                          <BusinessContentContainer contents={this.state.business.contents}/>
                        }
                      </div>

                      <ShowIf condition={viewAll}>
                        <div className='wrap-btn'>
                          <button className='btn-view-all btn-watched' onClick={this.viewAll.bind(this)}>Thu gọn</button>
                        </div>
                      </ShowIf>
                      <ShowIf condition={!viewAll}>
                        <div className='wrap-btn'>
                          <button className='btn-view-all' onClick={this.viewAll.bind(this)}>XEM TẤT CẢ</button>
                        </div>
                      </ShowIf>
                    </div>
                  </TabPanel>
                  <TabPanel className='business-tab-panel'>
                    {
                      this.state.business.paymentInfo && this.state.business.paymentInfo.map((paymentInfo, idx) => {
                        return (
                          <ItemPayment key={idx} {...paymentInfo} />
                        );
                      })
                    }
                  </TabPanel>
                  <TabPanel className='business-tab-panel'>
                    <ContactBusiness business={this.state.business}/>
                  </TabPanel>
                </Tabs>
              </div>
              <ShowIf condition={!isEmpty(this.state.query)}>
                <ListProductResult data={this.state.data} />
              </ShowIf>
              <ShowIf condition={isEmpty(this.state.query) && this.state.listCategories.length === 0 && !isLoading}>
                <NoContent content='Chưa cập nhật sản phẩm/Dịch vụ nào' height={300}/>
              </ShowIf>
              <ShowIf condition={!isEmpty(this.state.query) && !isLoading && this.state.data.length > 0 && (skip + limit) < count}>
                <button type="button" className="btn-viewmore-product" onClick={this.loadMore}>
                  <span className="btn-viewmore-text">Xem Thêm</span>
                </button>
              </ShowIf>
              <ShowIf condition={isEmpty(this.state.query)}>
                <div className='business-list-item-category'>
                  {
                    this.state.listCategories.map((item, i) => {
                      return (
                        <ItemCategory for="business" key={i} businessId={this.state.business.id} businessSlug={this.state.business.nameSlug} category={item}/>
                      );
                    })
                  }
                </div>
              </ShowIf>
            </div>
            {
              this.state.listCategories && this.state.listCategories.length > 0 &&
              <div className="business-right-content">
                <BusinessProductCategories
                  productCategories={this.state.listCategories}
                  onItemClick={this.scrollToCategory.bind(this)}
                />
                {
                  this.state.business && this.props.auth && this.props.auth.isAdmin &&
                  <SignInToBusinessForm
                    businessId={this.state.business.id}
                  />
                }

              </div>
            }
          </div>
        </div>
      </section>
    );
  }
}

const bindStateToProps = (state) => {
  return {
    auth: state.auth
  }
}

export default withRouter(connect(bindStateToProps)(Business));



// WEBPACK FOOTER //
// ./components/business/business-page/Business.jsx